import { render, staticRenderFns } from "./UsageGuideCard.vue?vue&type=template&id=32673735&scoped=true"
import script from "./UsageGuideCard.vue?vue&type=script&lang=ts"
export * from "./UsageGuideCard.vue?vue&type=script&lang=ts"
import style0 from "./UsageGuideCard.vue?vue&type=style&index=0&id=32673735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32673735",
  null
  
)

export default component.exports